import { Navigation } from "@/components/Navigation";
import { HeroSection } from "@/components/HeroSection";
import { ServicesGrid } from "@/components/ServicesGrid";
import { PrivacyManifesto } from "@/components/PrivacyManifesto";
import { ProcessTimeline } from "@/components/ProcessTimeline";
import { Testimonials } from "@/components/Testimonials";
import { ContactForm } from "@/components/ContactForm";
import { Footer } from "@/components/Footer";

export default function HomePage() {
  return (
    <main className="relative" data-testid="home-page">
      <Navigation />
      <HeroSection />
      <ServicesGrid />
      <PrivacyManifesto />
      <ProcessTimeline />
      <Testimonials />
      <ContactForm />
      <Footer />
    </main>
  );
}
